import { Phone, MessageCircle, MapPin, Instagram } from "lucide-react";
import { PHONE, PHONE_TEL, WA_LINK, LOGO_URL } from "../data/menuData";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111111] text-white pb-24 md:pb-10"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-12 md:py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <div className="w-12 h-12 brutal-border bg-black overflow-hidden flex items-center justify-center">
              <img
                src={LOGO_URL}
                alt="KKFC Bangarpet logo"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="leading-tight">
              <div className="font-display text-2xl">KKFC</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-neutral-400 -mt-1">
                Bangarpet
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm text-neutral-300 leading-relaxed">
            Bangarpet's favourite chicken spot — crispy, juicy and full of
            flavour. One bite and you'll keep coming back.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#FFB800] mb-3">
            Quick Links
          </div>
          <ul className="space-y-2 font-body text-sm">
            {[
              { label: "Menu", href: "#menu" },
              { label: "Why Us", href: "#why" },
              { label: "Reviews", href: "#reviews" },
              { label: "Gallery", href: "#gallery" },
              { label: "Contact", href: "#contact" },
            ].map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-neutral-200 hover:text-[#FFB800] transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#FFB800] mb-3">
            Reach Us
          </div>
          <div className="space-y-3 text-sm">
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="footer-call"
              className="flex items-center gap-3 text-neutral-200 hover:text-white"
            >
              <Phone size={16} className="text-[#FFB800]" /> {PHONE}
            </a>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-3 text-neutral-200 hover:text-white"
            >
              <MessageCircle size={16} className="text-[#25D366]" /> WhatsApp
              Order
            </a>
            <a
              href="https://instagram.com/kkfcbpet"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-3 text-neutral-200 hover:text-white"
            >
              <Instagram size={16} className="text-[#E4405F]" /> @kkfcbpet
            </a>
            <div className="flex items-center gap-3 text-neutral-200">
              <MapPin size={16} className="text-[#D92525]" /> Bangarpet,
              Karnataka
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-neutral-800">
        <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-400">
          <div>© {new Date().getFullYear()} KKFC Bangarpet. All rights reserved.</div>
          <div className="uppercase tracking-widest">
            Crispy • Juicy • Full-on Taste
          </div>
        </div>
      </div>
    </footer>
  );
}
